import { styled, css, useTheme } from '@vebox/etui-system';
import '../utilities/responsive.js';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { createElement } from 'react';
import '../utilities/get-styleprop.js';
import '../useDebounce/useDebounce.js';
import '../useWindowSize/useWindowSize.js';
import useResponsive from '../useResponsive/useResponsive.js';
import { b as _extends, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import 'react-dom';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';
import '../SideDrawer/utils.js';
import SideDrawer from '../SideDrawer/SideDrawer.js';

const SidePushPanelHeader = styled(Div)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: flex-start;
  width: 100%;
  height: 60px;
  ${({
  theme
}) => css`
    padding: ${theme.spacing.sm}px ${theme.spacing.md}px;
    background: ${theme.palette.grey[20]};
  `};
`;

const SidePushPanelWrapper = styled(Div)`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const SidePushPanelDrawer = ({
  title,
  panelWidth,
  children,
  isOpen = false,
  containerReference,
  handleOnClose,
  styles = {},
  sideDrawerProps = {}
}) => {
  const theme = useTheme();
  const {
    screenIsAtMost
  } = useResponsive({
    sm: parseInt(theme.breakpoints[1], 10)
  });
  const isSmView = screenIsAtMost('sm', ['portrait', 'landscape']);
  return /*#__PURE__*/createElement(SideDrawer, _extends({
    placement: "right",
    collapsed: !isOpen,
    useContainerOverflowHidden: false,
    getContainer: () => (containerReference === null || containerReference === void 0 ? void 0 : containerReference.current) || document.body,
    useOverlay: false
  }, sideDrawerProps, {
    styles: _objectSpread2(_objectSpread2({}, styles), {}, {
      root: _objectSpread2({
        overflow: 'auto',
        width: isOpen ? isSmView ? '100%' : panelWidth : 0
      }, styles.root)
    })
  }), /*#__PURE__*/createElement(SidePushPanelWrapper, styles.wrapper, /*#__PURE__*/createElement(SidePushPanelHeader, styles.header, /*#__PURE__*/createElement(Div, {
    display: "flex",
    alignItems: "center"
  }, title && /*#__PURE__*/createElement(Div, {
    ml: `${theme.spacing.sm}px`
  }, title)), /*#__PURE__*/createElement(Button, _extends({
    iconOnly: true,
    iconProps: {
      glyph: icons.CLOSE,
      size: 32
    },
    p: 0,
    onClick: () => handleOnClose(isOpen)
  }, styles.closeButton))), children));
};

export default SidePushPanelDrawer;
